<template>
	<div>
		<a-modal :visible="visible" :title="title" :closable="false">
			<template slot="footer">
				<a-button key="back" @click="onCancel"> Cancelar </a-button>
				<a-button key="submit" class="btn btn-success" @click="handleSubmit"> {{ submitLabel }} </a-button>
			</template>
			<a-spin :tip="spinnerLoaderLabel" size="small" :spinning="spinnerLoader">
				<a-form layout="vertical" :form="form" @submit="handleSubmit">
					<div class="row">
						<div class="col-md-6">
							<a-form-item label="Área">
								<a-input
									v-decorator="[
										'name',
										{
											rules: [
												{
													required: true,
													message: 'Campo requerido.',
												},
											],
										},
									]"
									autocomplete="off"
								/>
							</a-form-item>
						</div>
						<div class="col-md-6">
							<a-form-item label="Responsable">
								<a-select
									v-decorator="[
										'attendant',
										{
											rules: [
												{
													required: true,
													message: 'Campo requerido.',
												},
											],
										},
									]"
								>
									<a-select-option v-for="(user, index) in usersList" :key="index" :value="user.user_id">{{ user.fullName }}</a-select-option>
								</a-select>
							</a-form-item>
						</div>
					</div>
				</a-form>
			</a-spin>
		</a-modal>
	</div>
</template>
<script>
import { mapGetters } from 'vuex'
import utilities from '@/services/utilities'

export default {
	name: 'insertOrUpdateBusinessArea',
	components: {},
	props: {
		visible: {
			type: Boolean,
			default: false,
		},
		title: {
			type: String,
			default: '',
		},
		payload: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	computed: {
		...mapGetters('users', ['usersList']),
		spinnerLoaderLabel() {
			return this.$store.state.businessAreas.spinnerLoaderLabel
		},
		spinnerLoader() {
			return this.$store.state.businessAreas.spinnerLoader
		},
	},
	data() {
		return {
			form: this.$form.createForm(this),
			submitLabel: '',
		}
	},
	methods: {
		onCancel() {
			this.$emit('closeModal')
			this.form.resetFields()
		},
		handleSubmit(e) {
			e.preventDefault()
			this.form.validateFields((err, values) => {
				if (!err) {
					//
					let payload = {
						...values,
					}
					if (utilities.objectValidate(this.payload, 'id', false)) {
						payload.id = this.payload.id

						this.$store.dispatch('businessAreas/UPDATE', payload).then((response) => {
							this.onCancel()
						})
					} else {
						this.$store.dispatch('businessAreas/CREATE', payload).then((response) => {
							this.onCancel()
						})
					}
				}
			})
		},
	},
	watch: {
		payload(newValue) {
			setTimeout(() => {
				//console.log(newValue)
				if (utilities.objectValidate(newValue, 'id', false)) {
					this.form.setFieldsValue({
						name: utilities.objectValidate(newValue, 'name', ''),
						attendant: utilities.objectValidate(newValue, 'attendant_id', ''),
					})
					this.submitLabel = 'Actualizar'
				} else {
					this.submitLabel = 'Guardar'
				}
			}, 100)
		},
		visible(isVisible) {
			if (isVisible && this.usersList.length == 0) {
				this.$store.dispatch('users/GET')
			}
		},
	},
}
</script>
<style lang="scss" module>
@import './style.module.scss';
</style>